import React from 'react';
import { TemplateRouteContext } from '.';

function useRoute() {
    const context = React.useContext(TemplateRouteContext);
    return context;
}

export default useRoute;
